import { LeagueConfig, Environment } from "@leagueplatform/core";
import { createReactRouterAdapter } from "@leagueplatform/react-router-adapter";
import { APP_ID } from "common/constants";
import EN_LOCALES from "locales/en.json";
import ES_LOCALES from "locales/es.json";
import ZH_LOCALES from "locales/zh.json";

import { emblemHealthTheme } from "theme/theme";

const { VITE_APP_ENV } = import.meta.env;

export const config: LeagueConfig = {
  core: {
    clientId: APP_ID,
    // No-ops: auth is required by the config schema but this site has no auth requirements.
    // Both fields must be provided together — getToken alone causes the SDK to make API
    // calls trying to set up a user session, which fails with no backend configured.
    auth: {
      getToken: () => Promise.resolve(""),
      getUserIdFromMobileHandoff: () => Promise.resolve(""),
    },
    // Empty: this site makes no API calls. Non-empty values would trigger sdk-configs network requests.
    api: { url: "", wsUrl: "", legacyRestApi: "" },
    appEnvironment: VITE_APP_ENV as Environment,
    // Empty: required by schema but unused — this site fetches no content from League's CDN.
    contentUrl: "",
    routing: { adapter: createReactRouterAdapter() },
    ui: {
      theme: emblemHealthTheme,
    },
    i18n: {
      strings: {
        default: EN_LOCALES,
        en: EN_LOCALES,
        es: ES_LOCALES,
        zh: ZH_LOCALES,
      },
    },
  },
};
